import React from "react";
import "./Home.css";

function Home2() {
  return (
    <div className="heading-containerr">
      <h2 id="home2-head2">What Do You Want to Know About Pregnancy?</h2>
      <div className="animated-heading-container">
        <h3 className="animated-heading">Overview</h3>
        <span className="underline"></span>
      </div>
      <p style={{ textAlign: "justify", marginTop: "20px", color: "grey" }}>
        Pregnancy starts when sperm enters the egg during ovulation. The sperm
        fertilizes the egg, and the fertilized egg travels to the uterus, where
        it implants and starts growing. Pregnancy lasts about 40 weeks and has
        three stages. In the first trimester, the baby starts developing, and
        the mother may feel tired and sick. In the second trimester, the baby
        grows, and the mother feels better. In the third trimester, the baby
        gets ready for birth, and the mother may feel uncomfortable. Regular
        check-ups are important throughout the journey.
      </p>
      <div className="animated-heading-container">
        <h3 className="animated-heading">Missing Periods</h3>
        <span className="underline"></span>
      </div>
      <p style={{ textAlign: "justify", marginTop: "20px", color: "grey" }}>
        Missing a period is often one of the first signs of pregnancy. It
        happens when the fertilised egg implants in the uterus and the body
        stops preparing for a new cycle. If a woman misses her period and thinks
        she might be pregnant, taking a home pregnancy test is a good way to
        check.
      </p>
    </div>
  );
}

export default Home2;
